import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {GuideForm} from "../../models/guide-form";
import {IFormHistory} from "../../models/form-history-interface";
import {BaseForm} from "../../models/base-form";
import Helpers from "../../utils/helpers";

@Injectable()
export class GuideFormControllerService implements IFormHistory {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getHistoryPage(serviceId: string, page: number): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/guide-form/pagedhistory?pageNo=" + page + "&pageSize=12") as Observable<any[]>;
  }

  public getGuideForm(serviceId: string, reusable: boolean): Observable<GuideForm> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/guide-form?reusable=" + reusable) as Observable<GuideForm>;
  }

  public createGuideForm(serviceId: string, form: BaseForm): Observable<GuideForm> {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/guide-form", body) as Observable<GuideForm>;
  }

  public saveGuideForm(form: GuideForm) {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.put(this.baseUrl + "guide-form/" + form.id, body, {responseType: "text"});
  }

  public activateGuideForm(formId: string, active: boolean) {
    return this.http.put(this.baseUrl + "guide-form/activate/" + formId + "/" + active, null, {responseType: "text"});
  }

  public getHistory(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/guide-form/history") as Observable<any[]>;
  }

  // Get form schema for preview only (GET request)
  public getFormSchemaForRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/guide-form/history/" + revisionNumber + "/schema") as Observable<any>;
  }

  // Revert form to a specific revision (PUT request - triggers cleanup of orphaned relations)
  public revertFormToRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.put(this.baseUrl + "service/" + serviceId + "/guide-form/history/" + revisionNumber, null, {responseType: "text"}) as Observable<any>;
  }

}
